import Component from 'vue-class-component';
import moduleStore from './store/sameStyle';
import Vue from 'vue';
import PageState from './store/state';
import { getQueryString } from '@/utils/location';
/**components**/
@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class sameStylePage extends Vue implements IvuePage<PageState> {
  state = new PageState();
  self: Vue = this;
  tabList = [];
  tabIndex = 0;
  templates = [];
  pageIndex = 0;
  totalPage = null;
  loading = false; //是否数据在加载中
  finished = false; //当前所有数据是否加载完成
  showPopup = false; //是否展示弹框
  tabType = ''; //当前tab类型
  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
    let ww_token = getQueryString('ww_token');
    let platform = getQueryString('platform');
    if(platform){
      localStorage.setItem('platform',platform)
    }
    if (ww_token) {
      this.state.ww_token = ww_token;
    }
  }
  mounted(moduleData: IinjectDatas) {
    document.title = '一键剪同款';
    this.state.self = this;
    this.getTypeListFn();
    this.showPopup = !localStorage.getItem('hasRead');//已读不展示
  }
  getTypeListFn() {
    this.$http('getTypeList').then(res => {
      if (res.code == 200) {
        res.data.unshift('全部');
        this.tabList = res.data;
      }
    });
  }
  getTemplateListFn(more = false) {
    this.finished = false;
    this.loading = true;
    let queryData = {
      page: this.pageIndex,
      pageSize: 10,
      type: this.tabType,
    };
    this.$http('getTemplateList', queryData).then(res => {
      if (res.code == 200) {
        this.totalPage = res.data.total_pages;
        this.templates = more ? this.templates.concat(res.data.results) : res.data.results;
      } else {
        this.$toast('模版查询失败');
      }
    });
    this.loading = false;
  }
  onLoadMore() {
    this.pageIndex++;
    if (this.totalPage!=null && this.pageIndex > this.totalPage) {
      this.finished = true;
      this.loading = false;
      return;
    }
    this.getTemplateListFn(true);
  }
  tabClick(idx) {
    this.tabIndex = idx;
    this.pageIndex = 0;
    this.totalPage = null;
    this.templates = [];
    this.loading = true;
    this.finished = false;
    this.tabType = idx==0?'':this.tabList[idx];
    this.onLoadMore();
  }
  gotMsg() {
    this.showPopup = false;
    localStorage.setItem('hasRead', 'true');
  }
  doTheSame(item) {
    //登录之后跳转过去的地址
    let jumpUrl = `${location.origin}/#/cutDetail?id=${item.id}&type=${'template'}`
    //登录校验
    let token = this.state.ww_token;
    let templateName = item.title; 
    if (!token) {
      this.$navigateTo({
        url: `/pages/login/login?redirect=${encodeURIComponent(
          `/pages/webview/webview?url=${encodeURIComponent(jumpUrl)}&navtitle=${templateName}&from=sameType`
        )}`,
      });
      return;
    } else {
        let url2 = `/pages/webview/webview?url=${encodeURIComponent(jumpUrl)}&navtitle=${templateName}&from=sameType`
        this.$navigateTo({
          url:url2
        });
    }
  }
}
